module.exports = __webpack_public_path__ + "static/media/cup.c2c00de8.svg";